/* eslint-disable */

import actions from './actions'

export default function INVOICEDETAILsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVOICEDETAIL:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVOICEDETAIL:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVOICEDETAIL:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVOICEDETAIL:
      return {
        ...state,
        editing: { invoiceDetailID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.DELETE_INVOICEDETAIL_RECIEVED:
      return {
        ...state,
        editing: { invoiceDetailID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
